import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
//
import LanguageToggle from './../../core/language-toggle/LanguageToggle';
import DelayedRedirect from '../../core/redirect/DelayedRedirect';
import AmplifyWrapper from '../../../service/auth.service';
import { renderErrors, renderMessages } from '../../render';
import validateField from '../../validation';
import { login } from '../../../actions/login-actions';
import constants from '../../../constants';
import { setupFacebook } from '../../../service/facebook-helper.service';
import './SignIn.scss';

/**
 * 
 */
class SignIn extends React.Component {
	/**
     * 
     * @param {*} props 
     */
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			password: '',
			code: '',
			formValid: false,
			errors: [],
			messages: [],
			isLoading: false
		};
	}

	/**
     * 
     */
	componentDidMount() {
		// Create window.FB object
		setupFacebook(constants.facebook.appId);
	}

	// - - Submit button

	/**
     * 
     */
	handleSubmitClick = () => {
		this.props.login(this.state.username, this.state.password);
	};

	/**
     * 
     * @param {*} e 
     */
	handleChange(e) {
		this.setState({ [e.target.id]: e.target.value });
		setTimeout(this.validateForm.bind(this, 200));
	}

	// - - Form handling

	/**
     * 
     */
	validateForm() {
		if (validateField('username', this.state.username) === true && validateField('password', this.state.password) === true) {
			this.setState({ formValid: true });
		} else {
			this.setState({ formValid: false });
		}
	}

	// - - Facebook

	/**
     * 
     */
	checkFBLoginState = () => {
		window.FB.getLoginStatus(this.fbStatusChangeCallback.bind(this));
	};

	/**
     * 
     */
	handleFBButtonClick = () => {
		window.FB.login(this.checkFBLoginState, { scope: 'public_profile, email' });
	};

	/**
     * 
     */
	fbStatusChangeCallback = response => {
		if (response.status === 'connected') {
			this.handleFBResponse(response.authResponse);
		} else {
			this.handleFBError(response);
		}
	};

	/**
     * 
     * @param {*} error 
     */
	handleFBError(error) {
		console.log(error);
	}

	/**
     * 
     * @param {*} data 
     */
	async handleFBResponse(data) {
		const { email, accessToken, expiresIn } = data;
		const expires_at = expiresIn * 360000 + new Date().getTime();
		const user = { email };

		try {
			/* const response =  */ await AmplifyWrapper.federatedSignIn('facebook', { accessToken, expires_at }, user);
			AmplifyWrapper.currentAuthenticatedUser({
				bypassCache: true
			})
				.then(user => {
					console.log('Facebook login Ok!', user);
				})
				.catch(err => {
					console.log(err);
				});
		} catch (e) {
			this.handleError(e);
		}
	}

	// - - Rendering

	/**
     * 
     */
	render() {
		const redirect = this.props.user.isAuthenticated === true ? <DelayedRedirect to="/dashboard" /> : null;

		// Otherwise render the page
		let app = (
			<div className="SignIn">
				{redirect}
				<div className="container">
					<div className="simpleMenu">
						<LanguageToggle />
					</div>
					<h1>
						{this.props.t('translation:signin:headerLbl')}
					</h1>
					<form noValidate autoComplete="off">
						<div className="formBox">
							<div>
								<TextField
									id="username"
									label={this.props.t('translation:signin:usernameInputLabel')}
									margin="normal"
									variant="outlined"
									value={this.state.username}
									disabled={this.props.isLoading}
									onChange={e => this.handleChange(e)}
								/>
							</div>
							<div>
								<TextField
									id="password"
									type="password"
									label={this.props.t('translation:signin:passwordInputLabel')}
									margin="normal"
									variant="outlined"
									value={this.state.password}
									disabled={this.props.isLoading}
									onChange={e => this.handleChange(e)}
								/>
							</div>
							{/* <div>
								<TextField
									id="code"
									label={this.props.t('translation:signin:codeInputLabel')}
									margin="normal"
									variant="outlined"
									value={this.state.code}
									disabled={this.props.isLoading}
									onChange={e => this.handleChange(e)}
								/>
							</div> */}
						</div>
						<div className="feedbackBox">
							<div className="messages">
								{renderMessages.bind(this)(this.props.messages)}
							</div>
							<div className="errors">
								{renderErrors.bind(this)(this.props.errors)}
							</div>
						</div>
						<div>
							<div>
								<Button className="btnAction" variant="contained" color="primary" onClick={this.handleSubmitClick} disabled={this.props.isLoading || !this.state.formValid}>
									{this.props.t('translation:signin:submitButtonLabel')}
								</Button>
								<div className="links">
									<Link to={'/signup'}>{this.props.t('translation:signin:gotoCreateAcountButtonLabel')}</Link> |{' '}
									<Link to={'/request-reset-password'}>{this.props.t('translation:signin:gotoResetPasswordButtonLabel')}</Link>
								</div>
								<Button className="btnFacebook btnAction" variant="contained" color="primary" onClick={this.handleFBButtonClick} disabled={this.props.isLoading}>
									{this.props.t('translation:signup:facebookBtnLabel')}
								</Button>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
		return app;
	}
}

/**
 * 
 * @param {*} state 
 */
const mapStateToProps = state => {
	return {
		user: state.user,
		isLoading: state.login.isLoading,
		//isLoggedIn: state.login.isLoggedIn,
		errors: state.login.errors,
		messages: state.login.messages
	};
};

/**
 * 
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
	return {
		login: (username, password) => dispatch(login(username, password))
	};
};

/**
 * 
 */
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SignIn));
